/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Añadir"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Eliminar todo"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var esES = Object.assign(TranslationProviderComponent, {
  translations
});

export { esES as e };
//# sourceMappingURL=es-ES-Dpvpwv0L.js.map
